import { Routes } from "@angular/router";
import { BacOrdersBreakdownChartComponent } from "./components/bac-orders-breakdown-chart/bac-orders-breakdown-chart.component";
import { BcBacSupportBreakdownComponent } from "./components/bc-bac-support-breakdown/bc-bac-support-breakdown.component";
import { BcGpSupportTableComponent } from "./components/bc-gp-support-table/bc-gp-support-table.component";
import { BilledOrdersYtdChartComponent } from "./components/billed-orders-ytd-chart/billed-orders-ytd-chart.component";
import { QuarterlySupportTableComponent } from "./components/quarterly-support-table/quarterly-support-table.component";
import { SupportMapPieChartComponent } from "./components/support-map-pie-chart/support-map-pie-chart.component";
import { TigerLevelGpChartComponent } from "./components/tiger-level-gp-chart/tiger-level-gp-chart.component";
import { BacBasCurrentSupportTableComponent } from "./components/bac-bas-current-support-table/bac-bas-current-support-table.component";
import { DashboardPocComponent } from "./dashboard-poc.component";
import { ManagerReportComponent } from "./components/manager-report/manager-report.component";
import { MultiLedgerAssociationComponent } from "./components/multi-ledger-association/multi-ledger-association.component";
import { RoleGuard } from "../../core/guards/role/role.guard";
import { UserRole } from "../../shared/enums/userRoles.enum";
import { userEmails } from "../../shared/constants/support-allocation-user-list";

export const dashboardPOCRoutes: Routes = [
  {
    path: "",
    data: {
      roles: [UserRole.Admin],
      emails: userEmails,
    },
    component: DashboardPocComponent,
  },
  {
    path: "bac-bas-current-support-table",
    component: BacBasCurrentSupportTableComponent,
  },
  {
    path: "bac-orders-breakdown-chart",
    component: BacOrdersBreakdownChartComponent,
  },
  {
    path: "bc-bac-support-breakdown.component",
    component: BcBacSupportBreakdownComponent,
  },
  {
    path: "bc-gp-support-table",
    component: BcGpSupportTableComponent,
  },
  {
    path: "billed-orders-ytd-chart",
    component: BilledOrdersYtdChartComponent,
  },
  {
    path: "quarterly-support-table",
    component: QuarterlySupportTableComponent,
  },
  {
    path: "support-map-pie-chart",
    component: SupportMapPieChartComponent,
  },
  {
    path: "tiger-level-gp-chart",
    component: TigerLevelGpChartComponent,
  },
  {
    path: "manager-report",
    component: ManagerReportComponent,
  },
  {
    path: "multi-ledger-association",
    canActivate: [RoleGuard],
    data: {
      roles: [UserRole.Admin],
    },
    component: MultiLedgerAssociationComponent,
  },
];
